import React from 'react';

const Advantages = () => {
  const advantages = [
    {
      icon: "ri-time-line",
      title: "Save Time & Reduce Costs",
      description: "Our automation systems cut processing time by up to 40% and eliminate costly manual errors that slow your business down."
    },
    {
      icon: "ri-arrow-up-line",
      title: "Measurable Growth Impact",
      description: "Track real ROI with systems designed to increase efficiency, improve customer satisfaction, and drive revenue growth."
    },
    {
      icon: "ri-team-line",
      title: "Empower Your Team",
      description: "Free your team from repetitive tasks so they can focus on strategic work that grows your business."
    },
    {
      icon: "ri-error-warning-line",
      title: "Eliminate Process Bottlenecks",
      description: "Identify and remove the friction points in your operations that cause delays, errors, and customer frustration."
    },
    {
      icon: "ri-database-2-line",
      title: "Data-Driven Decision Making",
      description: "Get real-time visibility into your operations with dashboards and analytics that help you make smarter business decisions."
    },
    {
      icon: "ri-hand-heart-line",
      title: "Startup-Friendly Partnership",
      description: "Flexible pricing and payment plans designed for growing businesses. We succeed when you succeed."
    }
  ];

  return (
    <section id="advantages" className="py-20 bg-gray-50">
      <div className="container mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-3xl font-bold text-gray-900 mb-4">The Business Impact We Deliver</h2>
          <div className="w-20 h-1 bg-primary mx-auto mb-8"></div>
          <p className="max-w-3xl mx-auto text-lg text-gray-700">
            Real results that matter to your business — not just features, but outcomes you can measure.
          </p>
        </div>
        
        <div className="grid md:grid-cols-3 gap-8 max-w-6xl mx-auto">
          {advantages.map((advantage, index) => (
            <div key={index} className="bg-white p-8 rounded-lg shadow-sm hover:shadow-md transition-all group">
              <div className="w-14 h-14 bg-primary/10 rounded-full flex items-center justify-center mb-6 group-hover:bg-primary/20 transition-colors">
                <i className={`${advantage.icon} ri-xl text-primary`}></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-3">{advantage.title}</h3>
              <p className="text-gray-700">{advantage.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Advantages;
